import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import StatsItem from './StatsItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  brandColorsContainer: {
    maxWidth: 1440,
    backgroundColor: '#033349',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    padding: '4.6875em',
    paddingTop: '4.375em',
    paddingBottom: '4.375em',
  },
  brandColorsBox: {
    backgroundColor: '#033349',
    padding: '0.0625em',
    paddingLeft: '2.25em',
    paddingRight: '2.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  mediaLogoUsageContainer: {
    justifyContent: 'flex-start',
    paddingLeft: '0.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.323em',
      marginTop: 30
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      paddingLeft: '4.688em',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    }
  },
  colorsContainer: {
    justifyContent: 'space-evenly',
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    }
  },
  colorInfoBoxContainer: {
    maxWidth: 200,
    paddingTop: 20,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  colorInfoBox: {
    maxWidth: 100,
    paddingLeft: 10,
  },
  coloredbox01: {paddingLeft: 0,
    backgroundColor: '#40A6AE',
    width: 75,
    height: 75
  },
  coloredbox02: {
    backgroundColor: '#2C7479',
    width: 75,
    height: 75
  },
  coloredbox03: {
    backgroundColor: '#FFFFFF',
    width: 75,
    height: 75
  }
});


const BrandColorsContainer: React.SFC<WithStyles> = ({
  classes
}) => {
  return (
    <Grid item container direction="row" className={classes.brandColorsContainer}>
      <Grid item container direction="column" className={classes.brandColorsBox}>
        <Grid item>{localizations.mediaPageView.serviceBrand}</Grid>
        <Grid item>
            <p>{localizations.mediaPageView.serviceBrandParagraph01}</p>
        </Grid>
      </Grid>
      <Grid item container direction="row" >
        <Grid item container direction="row" className={classes.colorInfoBoxContainer}>
          <Grid item>
            <div className={classes.coloredbox01} />
          </Grid>
          <Grid item container direction="column" className={classes.colorInfoBox}>
            <Grid item>
              <b>{localizations.mediaPageView.serviceBrandColorTitle01}</b>
              <br />
              {localizations.mediaPageView.serviceBrandColorRGB01}
              <br />
              {localizations.mediaPageView.serviceBrandColorHex01}
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction="row" className={classes.colorInfoBoxContainer}>
          <Grid item>
            <div className={classes.coloredbox02} />
          </Grid>
          <Grid item container direction="column" className={classes.colorInfoBox}>
            <Grid item>
              <b>{localizations.mediaPageView.serviceBrandColorTitle02}</b>
              <br />
              {localizations.mediaPageView.serviceBrandColorRGB02}
              <br />
              {localizations.mediaPageView.serviceBrandColorHex02}
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction="row" className={classes.colorInfoBoxContainer}>
          <Grid item>
            <div className={classes.coloredbox03} />
          </Grid>
          <Grid item container direction="column" className={classes.colorInfoBox}>
            <Grid item>
              <b>{localizations.mediaPageView.serviceBrandColorTitle03}</b>
              <br />
              {localizations.mediaPageView.serviceBrandColorRGB03}
              <br />
              {localizations.mediaPageView.serviceBrandColorHex03}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(BrandColorsContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/BrandColorsContainer.tsx